// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1QqZB","top":"styles_top__zQRKp"};